import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { BLOCKED_PAYMENT_STATUSES } from '../sales-order-payments/blocked-payment-statuses.js';
/** Cash on an undated order is a prepayment unless payment is blocked or the order already shipped. */
export const AR_NON_PREPAYMENT_STATUSES = [
    ...BLOCKED_PAYMENT_STATUSES,
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.COMPLETE,
];
//# sourceMappingURL=ar-non-prepayment-statuses.js.map